import dayjs from "dayjs";
import { clientFetch } from "@/utils/service";
import { isFunction, isEmpty, omit, convertFileToBase64 } from '@/utils/helpers';
import {
  FETCH_PSYCHOLOGIST,
  CREATE_PSYCHOLOGIST,
  UPDATE_PSYCHOLOGIST,
  FETCH_PSYCHOLOGIST_FEEDBACKS,
  FETCH_PSYCHOLOGIST_NEWS,
  CREATE_PSYCHOLOGIST_DIPLOMA,
  DELETE_PSYCHOLOGIST_DIPLOMA,
} from './actionsTypes';
import { toast } from "react-toastify";

export const fetchPsychologistApi = async (id) => clientFetch(`/admin/psychologists/${id}`);
export const fetchFiltersApi = async () => clientFetch(`/filters`);
export const fetchPsychologistSchedulerApi = async (id) => clientFetch(`/psychologists/${id}/schedulers`);

export const fetchPsychologistFeedbacks = (id) => {
  return {
    type: FETCH_PSYCHOLOGIST_FEEDBACKS,
    payload: clientFetch(`/psychologists/${id}/feedbacks`),
  };
};

export const fetchPsychologistNews = (id) => {
  return {
    type: FETCH_PSYCHOLOGIST_NEWS,
    payload: clientFetch(`/psychologists/${id}/posts`),
  };
};

export const fetchPsychologist = (id) => {
  return {
    type: FETCH_PSYCHOLOGIST,
    payload: fetchPsychologistApi(id),
  };
};

export const managePsychologist = async ({
  id,
  data = {},
  dispatch,
  onSuccess,
  onError,
}) => {
  const formData = {
    ...data,
    experience: dayjs(data?.experience).format(),
    photo: !isEmpty(data?.photo) ? data?.photo : undefined,
    video_mobile: data?.video_mobile === null
      ? null
      : typeof data?.video_mobile === 'object'
        ? await convertFileToBase64(data?.video_mobile)
        : undefined,
    video_desktop: data?.video_desktop === null
      ? null
      : typeof data?.video_desktop === 'object'
        ? await convertFileToBase64(data?.video_desktop)
        : undefined,
  };
  const path = !!id ? `/admin/psychologists/${id}` : '/admin/psychologists';
  const type = !!id ? UPDATE_PSYCHOLOGIST : CREATE_PSYCHOLOGIST;
  const method = !!id ? 'PATCH' : 'POST';

  return clientFetch(path, {
    method: method,
    body: JSON.stringify(formData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const addPsychologistDiploma = async ({
  data = {},
  dispatch,
  onSuccess,
  onError,
}) => {
  const path = `/admin/psychologists/diploma`;
  const type = CREATE_PSYCHOLOGIST_DIPLOMA;
  const method = 'POST';
  const normalizedData = omit(data, ['_id', 'isLoading'])

  return clientFetch(path, {
    method: method,
    body: JSON.stringify(normalizedData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess({ ...res, _id: data?._id });
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError({ ...err, _id: data?._id });
    });
};

export const deletePsychologistDiploma = (id, { onSuccess, t }) => {
  return {
    type: DELETE_PSYCHOLOGIST_DIPLOMA,
    payload: clientFetch(`/admin/psychologists/diploma/${id}`, {
      method: 'DELETE',
    })
      .then((res) => {
        toast.success(t('psychologist.diplomas.delete_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id };
      })
      .catch((err) => {
        toast.error(t('psychologist.diplomas.delete_error'));
      }),
  };
};